import React from "react";

const CopyStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 13.25C3.5335 13.25 2.75 12.4665 2.75 11.5V4.75C2.75 3.64543 3.64543 2.75 4.75 2.75H11.5C12.4665 2.75 13.25 3.5335 13.25 4.5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.25 6.75H8.75C7.64543 6.75 6.75 7.64543 6.75 8.75V15.25C6.75 16.3546 7.64543 17.25 8.75 17.25H15.25C16.3546 17.25 17.25 16.3546 17.25 15.25V8.75C17.25 7.64543 16.3546 6.75 15.25 6.75Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(CopyStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;